"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefaultCountryForBrand = exports.getDefaultCountryForBrand = exports.FULL_BRAND_NAME = exports.DEFAULT_COUNTRY_BY_BRAND = void 0;
const types_1 = require("../types");
/**
 * @deprecated There is no longer a default country for a Brand in the INTL context.
 */
exports.DEFAULT_COUNTRY_BY_BRAND = {
    [types_1.Brand.BK]: types_1.IsoCountryCode2Char.US,
    [types_1.Brand.LTW]: types_1.IsoCountryCode2Char.US,
    [types_1.Brand.PLK]: types_1.IsoCountryCode2Char.US,
    [types_1.Brand.TH]: types_1.IsoCountryCode2Char.CA,
    [types_1.Brand.FHS]: types_1.IsoCountryCode2Char.US,
};
exports.FULL_BRAND_NAME = {
    [types_1.Brand.PLK]: types_1.FullBrandName.Popeyes,
    [types_1.Brand.TH]: types_1.FullBrandName.TimHortons,
    [types_1.Brand.BK]: types_1.FullBrandName.BurgerKing,
    [types_1.Brand.FHS]: types_1.FullBrandName.FirehouseSubs,
    [types_1.Brand.LTW]: types_1.FullBrandName.LoveThatWing,
};
/**
 * Determine the default country value for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @returns {IsoCountryCode2Char}
 * The default 2-character ISO country code for the Brand.
 *
 * @deprecated There is no longer a default country for a Brand in the INTL context.
 * This method will be removed in a future release. Please, make sure your application
 * is always ready to handle issues when country is not provided.
 */
const getDefaultCountryForBrand = (brand) => {
    // this function should never be ran. our platform needs a real region to work on
    // let's find out where is called and find out why it needs to fallback on US region
    const err = new Error('test error, not thrown');
    // can't use logger as it creates a cyclic dependency :(
    // but hopefully Datadog will log this
    console.warn({
        deprecated: 1,
        message: 'deprecated getDefaultCountryForBrand called',
        stackTrace: err.stack,
    });
    return exports.DEFAULT_COUNTRY_BY_BRAND[brand];
};
exports.getDefaultCountryForBrand = getDefaultCountryForBrand;
/**
 * Given a country value, determine if it is the default country for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @param {IsoCountryCode2Char | string} country
 * A country value.
 *
 * @returns {boolean}
 * true - The country value is the default for the Brand.
 * false - Otherwise.
 *
 * @deprecated There is no longer a default country for a Brand in the INTL context.
 * This method will be removed in a future release. Please, make sure your application
 * is always ready to handle issues when country is not provided.
 */
const isDefaultCountryForBrand = (brand, country) => exports.getDefaultCountryForBrand(brand) === country;
exports.isDefaultCountryForBrand = isDefaultCountryForBrand;
//# sourceMappingURL=brand.js.map